<template>
  <v-container >
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="64">
          <v-toolbar
            flat
          >
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              今日
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="prev"
            >
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            type="category"
            category-show-all
            short-intervals
            :categories="categories"
            :events="events"
            :event-color="getEventColor"
            
          ></v-calendar>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  Array.prototype.remove = function() {
      var what, a = arguments, L = a.length, ax;
      while (L && this.length) {
          what = a[--L];
          while ((ax = this.indexOf(what)) !== -1) {
              this.splice(ax, 1);
          }
      }
      return this;
  };
  import axios from 'axios';
  export default {
    name: 'App',
    props: ['baseURL','baseLINE','baseAPI','baseADMIN','tax'],
    data: () => ({
      str_userid:"",
      str_groupid:"",
      UserName:"",
      focus: '',
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      categories: ['John Smith'],
    }),
    mounted () {
      this.$store.commit('SET_LAYOUT', "app-layout")
      let query = this.$route.query;
      this.str_userid = query['Userid'];
      this.str_groupid = query['Groupid'];
      try{
        this.UserName = query['UserName'];
      }catch{
        this.UserName = "姓名錯誤";
      }
      this.categories = [this.UserName];
      this.$refs.calendar.checkChange()
      this.$emit("menuShow",false);
      this.api_getAllTime();
    },
    methods: {
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      fetchEvents ({ start, end }) {
        const events = []

        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        const days = (max.getTime() - min.getTime()) / 86400000
        const eventCount = this.rnd(days, days + 20)

        for (let i = 0; i < eventCount; i++) {
          const allDay = this.rnd(0, 3) === 0
          const firstTimestamp = this.rnd(min.getTime(), max.getTime())
          
          const first = new Date(firstTimestamp - (firstTimestamp % 900000))
          console.log("隨機時間",firstTimestamp,first);
          const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
          const second = new Date(first.getTime() + secondTimestamp)

          events.push({
            name: this.names[this.rnd(0, this.names.length - 1)],
            start: first,
            end: second,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            timed: !allDay,
            category: this.categories[this.rnd(0, this.categories.length - 1)],
          })
        }

        this.events = events
        console.log("呼叫",this.events)
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      api_getAllTime(){
        const events = [];
        axios
        .get(this.baseURL+'/api/Manage/UserPunchData?Userid='+this.str_userid)
        .then((response)=>{
          let json_data = JSON.parse(JSON.parse(response.data));
          for(let i in json_data){
            let puchData = JSON.parse(json_data[i]["fPunchData"])
            if(puchData.loc!="error"){//顯示打卡成功資料
              let dt = new Date(puchData.time);
              // let datetext = dt.getHours()+":"+dt.getMinutes()+":"+dt.getSeconds();
              events.push({
                name: "在"+puchData.loc+"打卡成功",
                start: dt,
                end: dt,
                color: this.colors[this.rnd(0, this.colors.length - 1)],
                timed: true,
                category: this.UserName,
              })
              
            }
            
          }
          console.log(events);
          this.events = events
        })
        .catch(function (error) { // 请求失败处理
          console.log("錯誤資訊",error);
          // this.error("獲取ip失敗，請檢查是否有連上網路");
        });
      },
    },
  } 
  </script>
  <style>
    .text-shadow{
      /* text-shadow: 0.05em 0.05em 0.08em gray */
      text-shadow: -2px -2px white, 1px 1px #333
    }
    .text-blue-shadow{
      text-shadow: 0.05em 0.05em 0.08em #33347F;
    }
    .text-green-shadow{
      text-shadow: 0.05em 0.05em 0.08em #17A86C;
    }
    .position-center{
      position:absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  </style>